import { blogs_actions } from "./actionTypes";
import { apicall } from "../../services/api";
import { toast } from "react-toastify";

// Create Blog
export const createBlog = (payload) => async (dispatch) => {
  try {
    const response = await apicall("/resource-content/", "post", payload);
    // debugger
    // dispatch({ type: blogs_actions.CREATE_BLOGS, payload: response.data });
    toast.success(response?.data?.message);
  } catch (error) {
    dispatch({ type: blogs_actions.ERR_BLOGS, payload: error.message });
    toast.error("Failed to create blog.");
  }
};

// Get Blogs
export const getBlogs = (page=1,limit=10,search='') => async (dispatch) => {
  try {
    const response = await apicall(`/resource-content/get-all-content?page=${page}&limit=${limit}${search === "" ? ""  : `&${search}`}`, "get");
    dispatch({ type: blogs_actions.GET_BLOGS, payload: response.data });
  } catch (error) {
    dispatch({ type: blogs_actions.ERR_BLOGS, payload: error.message });
    toast.error("Failed to fetch blogs.");
  }
};

//View Blog
export const viewBlog = (id) => async (dispatch) => {
  try {
    const response = await apicall(`/resource-content/${id}/`, "get");
    dispatch({ type: blogs_actions.VIEW_BLOGS, payload: response.data.data });


  } catch (error) {
    dispatch({ type: blogs_actions.ERR_BLOGS, payload: error.message });
    toast.error("Failed to fetch blog details.");
  }
};

// Update Blog
export const updateBlog = (id, payload) => async (dispatch) => {
  try {
    const response = await apicall(`/resource-content/${id}/`, "patch", payload);
    
    dispatch({ type: blogs_actions.UPDATE_BLOGS, payload: response.data });
    toast.success("Blog updated successfully!");
  } catch (error) {
    dispatch({ type: blogs_actions.ERR_BLOGS, payload: error.message });
    toast.error("Failed to update blog.");
  }
};

// Delete Blog
export const deleteBlog = (id) => async (dispatch) => {
  try {
    const res = await apicall(`/resource-content/${id}/`, "delete");
    toast.success(res?.data?.message);
    dispatch(getBlogs());
    return
  } catch (error) {
    dispatch({ type: blogs_actions.ERR_BLOGS, payload: error.message });
    toast.error("Failed to delete blog.");
  }
};
